import { render } from "./AppBreadcrumb.vue?vue&type=template&id=5395dc92&scoped=true"
import script from "./AppBreadcrumb.vue?vue&type=script&lang=js"
export * from "./AppBreadcrumb.vue?vue&type=script&lang=js"

import "./AppBreadcrumb.vue?vue&type=style&index=0&id=5395dc92&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-5395dc92"

export default script